<script>
import FormLayout from "./_FormLayout.vue";
import {mapActions} from "vuex";

export default {
  name: "DriverMasterGeneralWasteEdit",
  components: {
    FormLayout,
  },
  mixins: [
  ],
  data () {
    return {
      product: null,
      breadcrumbs: [
        { text: "一般廃棄物処分業者一覧", disabled: false, to: "/driver/masters/general_waste_disposals", exact: true },
        { text: "一般廃棄物処分業者編集", disabled: true, to: "" },
      ],
      generalWasteDisposalId: null,
      reloadKey: 0,
      traderName: null,
    }
  },
  created() {
    this.generalWasteDisposalId = this.$route.params.id;
    this.setTraderName();
  },
  methods: {
    ...mapActions("DriverMasterGeneralWasteDisposal", {
      editGeneralWasteDisposal: "edit",
    }),

    /**
     * 閉じるボタン クリックイベントのコールバック
     */
    closeCallback () {
      this.$router.push({ name: 'DriverMasterGeneralWasteDisposals' })
    },

    /**
     * 登録ボタン クリックイベントのコールバック
     */
    registerCallback () {
      this.reloadKey = this.reloadKey + 1
      this.setTraderName();
    },

    setTraderName () {
      this.editGeneralWasteDisposal({ id: this.generalWasteDisposalId }).then((content) => {
        this.traderName = content.name;
      })
    },

  }
}
</script>

<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-alert
      outlined
      dense
      color="light-blue darken-4"
    >
      事業者名：{{ traderName }}
    </v-alert>
    <form-layout
      :key="reloadKey"
      :target-trader-id="generalWasteDisposalId"
      @closeCallback="closeCallback"
      @registerCallback="registerCallback"
    />
  </v-container>
</template>

<style scoped lang="scss">

</style>
